module.exports = __webpack_public_path__ + "static/media/icon-bouy.529f320c.svg";